import React from "react";

import {
  Button,
  Flex,
  Heading,
  Image,
  useMediaQuery,
  Box,
  Spinner
} from "@chakra-ui/react";

import api from "services/api";
import "./style.scss";
import {useWindowSize} from '../../utils/util-react';
import { useCustomToast } from "hooks/useToast";
import ErrorMessage from './components/error-message';
import ResgateProcess from './components/resgate-process'
import {ResgateProps} from './dominio'
import { v4 as uuidv4 } from 'uuid';
import { _t } from "content";

const ResgatePixPage = (props:any) => {

    const size = useWindowSize();
    const { getToast } = useCustomToast();
 
    const [pageState, setPageState] = React.useState<ResgateProps>(
        {
            saldo: 0, 
            processando: false, 
            retSaldo: false, 
            errorSaldo: false, 
            step: 1,
            resgateMinimo: 40,
            taxaConversao: 0.70,
            resgatePontos: undefined,
            resgateValor: undefined,
            chave: '',
            codigoConfirmacao: '',
            resgateRef: uuidv4(),
            bancoDestino: '',
            nomeTitular: '',
            resgateProcessoId: undefined,
            mensagemSucesso: 'Resgate registrado com sucesso',
            mensagemConfirmacao: 'Você receberá um código por SMS para confirmar o resgate!',
            tipoChavePix: '',
            mensagemBloqueioResgate: ''
        });

    React.useEffect(() => {
        const obterSaldo = async () => {
            if (pageState.processando === true)
                return;

            setPageState({...pageState, processando: true});
        try {
            const { data } = await api.get("/motorDePontos/saldoPontos");
            if (data && data.pontos !== undefined) {
                // Saldo atual: [{pageState.saldo} Ponto(s)] , valor inferior ao minimo
                let mensagemBloqueioResgate = data.mensagemBloqueioResgate === null ? undefined : data.mensagemBloqueioResgate;
                if (data.pontos < data.resgateMinimo && !data.mensagemBloqueioResgate) {
                    mensagemBloqueioResgate = `Saldo atual: [${data.pontos} Ponto(s)] , valor inferior ao minimo`;
                }
                setPageState({...pageState, saldo: data.pontos, mensagemBloqueioResgate: data.mensagemBloqueioResgate, resgateMinimo: data.resgateMinimo, taxaConversao: data.taxaConversao, retSaldo: true, processando: false, errorSaldo: false});
            }
            else {
                setPageState({...pageState, saldo: undefined, retSaldo: true, processando: false, errorSaldo: true});
            }
            } catch (error) {
                setPageState({...pageState, saldo: undefined, retSaldo: true, processando: false, errorSaldo: true});
            }
        }

        if (pageState.retSaldo === false) {
            obterSaldo();
        }

        
    }, []);

    const indexPg = !pageState.retSaldo
    ? 0
    : pageState.retSaldo && (pageState.errorSaldo === true || pageState.saldo === undefined)
      ? 1
      : Number(pageState.saldo) < Number(pageState.resgateMinimo)
        ? 2
        : 3;

    return (
        <>
        <div className="resgate_main">
            <div className="resgate_main_space"></div>
            <div className="resgate_main_content">
                {indexPg === 0 && 
                <Flex
                    margin="0px auto"
                    justifyContent="center"
                    marginBottom="auto"
                    marginTop={20}
                    height="100vh">
                    <Spinner size="xl" color={_t.color2} />
                </Flex>}
                {indexPg === 1 && <ErrorMessage >Falha ao obter seu saldo, não é possivel realizar resgate, tente mais tarde</ErrorMessage>}
                {indexPg === 2 && <ErrorMessage >{pageState.mensagemBloqueioResgate}</ErrorMessage>}
                {indexPg === 3 && <ResgateProcess 
                                    pageState={pageState} 
                                    setPageState={setPageState} 
                                  />}
            </div>
            <div className="resgate_main_space"></div>
        </div>
        </>
    );

}

export default ResgatePixPage;

